<template>
  <q-modal
    v-model="dialogTicketsTypes"
    :position="modalPosition"
    minimized
    @hide="$emit('change-modal-state', true)"
  >
    <div class="q-pa-md">
      <div>
        {{ $t('label.downloadTicket') }}
      </div>
      <q-list
        v-if="!googleWalletLoading"
        no-border
      >
        <q-item
          v-for="(ticket, index) in linkList"
          :key="index"
          :color="SET_COLOR_BUTTON.primary"
          :text-color="SET_COLOR_BUTTON.text.primary"
          :label="$t('label.downloadTicket')"
        >
          <q-item-main
            class="text-center"
          >
            <component
              :is="getDownloadButton(ticket.type)"
              :ticket="ticket"
              @start-download="download"
            />
          </q-item-main>
        </q-item>
      </q-list>
      <div
        v-else
        class="loading"
      >
        <q-spinner
          color="deep-purple"
          size="3em"
          :thickness="10"
        />
      </div>
    </div>
  </q-modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DownloadTicketAppleWalletButton from 'components/button/seat/downloadTicketAppleWallet';
  import DownloadTicketGoogleWalletButton from 'components/button/seat/downloadTicketGoogleWallet';
  import DownloadTicketPdfButton from 'components/button/seat/downloadTicketPdf';
  import { TICKET_TYPE_APPLE_WALLET, TICKET_TYPE_GOOGLE_WALLET } from 'helpers/constants/tickets';

  export default {
    name: 'DownloadTicketModal',
    props: {
      linkList: {
        type: Array,
        required: true,
      },
      toggleModal: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      dialogTicketsTypes: false,
      downloadButtonClicked: false,
    }),
    computed: {
      ...mapGetters('googleWallet', [
        'googleWalletLoading',
      ]),
      modalPosition() {
        return this.$q.platform.is.mobile
          ? 'bottom'
          : '';
      },
    },
    watch: {
      toggleModal(value) {
        this.dialogTicketsTypes = value;
      },
      googleWalletLoading(value) {
        if (!value && this.downloadButtonClicked) {
          this.$emit('change-modal-state');
        }
      },
    },
    methods: {
      download(ticket) {
        this.downloadButtonClicked = true;
        this.$emit('download', ticket);
        if (ticket.type !== TICKET_TYPE_GOOGLE_WALLET || !this.googleWalletLoading) {
          this.$emit('change-modal-state');
        }
      },
      getDownloadButton(type) {
        switch (type) {
          case TICKET_TYPE_APPLE_WALLET:
            return DownloadTicketAppleWalletButton;
          case TICKET_TYPE_GOOGLE_WALLET:
            return DownloadTicketGoogleWalletButton;
          default:
            return DownloadTicketPdfButton;
        }
      },
    },
  };
</script>

<style scoped>
.loading {
  text-align: center;
  margin-top: 35px;
  min-height: 100px;
}
</style>
